import React, { FC, useState, useCallback } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AssistantTodoItem } from '@dreamai/types';
import { useOnboardingModals } from '../../../providers';
import './dismiss-todo-modal.scss';

interface DismissTodoModalProps {
  show: boolean;
  todo: AssistantTodoItem | null;
  onClose: () => void;
  onConfirm: (todo: AssistantTodoItem) => void;
}

const DismissTodoModal: FC<DismissTodoModalProps> = ({
  show,
  todo,
  onClose,
  onConfirm,
}) => {
  const { markAsSeen } = useOnboardingModals();
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleConfirm = useCallback(async () => {
    if (dontShowAgain) {
      markAsSeen('dismiss_todo_warning').catch(() => {});
    }
    if (todo) {
      onConfirm(todo);
    }
    onClose();
  }, [dontShowAgain, markAsSeen, todo, onConfirm, onClose]);

  const handleClose = useCallback(() => {
    setDontShowAgain(false);
    onClose();
  }, [onClose]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className='dismiss-todo-modal'
    >
      <Modal.Body>
        <div className='content'>
          <h2 className='title'>Stop this task?</h2>
          <p className='text'>
            This will stop your assistant from working on this task. Any
            progress made so far will be lost.
          </p>
        </div>
        <div className='dont-show-again'>
          <label className='checkbox-label'>
            <input
              type='checkbox'
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
            />
            <span>Don't show this warning again</span>
          </label>
        </div>
        <div className='actions'>
          <Button
            variant='outline-secondary'
            onClick={handleClose}
            className='button cancel'
          >
            Cancel
          </Button>
          <Button
            variant='danger'
            onClick={handleConfirm}
            className='button confirm'
          >
            Stop task
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DismissTodoModal;
